import { Companies } from '../../companies/companies';

import { isValidCompanyName } from './isValidCompanyName';

type Company = (() => React.JSX.Element) | undefined;

export const getCompany = (companyName: string | null): Company => {
  if (!companyName || !isValidCompanyName(companyName, Companies)) {
    return undefined;
  }

  return Companies[companyName];
};
